import "./css/reset.css"
import "./css/colors.css"
import "./css/typography.css"
import "./css/themes.css"
import "./css/utils.css"
import "./css/layout.css"
import "./css/icons.css"
import "./css/buttons.css"
import "./css/forms.css"
import "./css/header.css"
import "./css/footer.css"
import "./css/admin.css"
import "./css/variables.css"
import "./css/plugins.css"
import "./css/sharing.css"
import "./css/mood.css"
import "./css/motives.css"
import "./css/details.css"
import "./css/f3cc.css"

import htmx from "htmx.org"
import { initBurgerMenu, initScrolledNav } from "./js/components/nav"
import { onReady } from "./js/utils/dom"

window.htmx = htmx

onReady(initBurgerMenu, true)
onReady(initScrolledNav, true)
onReady(() => {
  const boostEl = document.getElementById("boost")
  if (boostEl) {
    const body = document.body
    for (const className of body.className.split(" ")) {
      if (className.startsWith("theme--")) body.classList.remove(className)
    }
    document.body.classList.add(boostEl.className)
  }
}, true)
